import { useCallback, useEffect, useState } from 'react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { initializeMsal } from './msalInstance';
import { isMicrosoftLoginEnabled, loginRequest } from './msalConfig';

const useMicrosoftLogin = () => {
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const enabled = isMicrosoftLoginEnabled();

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let active = true;

    initializeMsal()
      .then(() => {
        if (active) {
          setReady(true);
        }
      })
      .catch(error => {
        console.error('Erro ao inicializar MSAL', error);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  const loginWithMicrosoft = useCallback(async () => {
    if (!enabled) {
      return null;
    }

    setLoading(true);

    try {
      const instance = await initializeMsal();
      if (!instance) {
        return null;
      }

      const result = await instance.loginPopup(loginRequest);
      return {
        idToken: result.idToken,
        accessToken: result.accessToken,
        account: result.account,
      };
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn('Interação adicional necessária para login Microsoft', error);
      } else if (error?.errorCode !== 'user_cancelled') {
        console.error('Erro no login Microsoft', error);
      }
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  return {
    enabled,
    ready,
    loading,
    loginWithMicrosoft,
  };
};

export default useMicrosoftLogin;
